import { ArchBaseService } from "@/common/api.service";
import {
  GET_BANKLIST,
  GET_BANK_BRANCHLIST_BYBANK,
  GET_BANKACCOUNTS,
  GET_BANKACCOUNT_DETAILS,
  UPDATE_BANKACCOUNT_DETALS,
  DELETE_BENEFICIARY_BANKACCOUNT,
  GET_CUSTOMERS_BY_BANKACCOUNT,
  GET_MOBILE_NETWORKS,
  GET_MOMOACCOUNTS,
  GET_MOBILE_MONEY_BY_ID,
  UPDATE_MOBILE_NETWORKS,
  DELETE_BENEFICIARY_MOBILE_MONEY,
  GET_CUSTOMERS_BY_MOMOWALLET,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
};

const getters = {
  //
};

const actions = {
  // BankList
  async [GET_BANKLIST](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    // context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`bank/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Banck branches by bank list
  async [GET_BANK_BRANCHLIST_BYBANK](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(
        `bank/local-codes/${payload.bank_code}/${payload.params}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get bank accounts
  async [GET_BANKACCOUNTS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/bank/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Bank Details by id
  async [GET_BANKACCOUNT_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/bank/id/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Update Bank account by id
  async [UPDATE_BANKACCOUNT_DETALS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(`accounts/bank/update/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Delete beneficiary Bank account by id
  async [DELETE_BENEFICIARY_BANKACCOUNT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(`accounts/bank/delete/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get Customers Associated with a Bank Account
  async [GET_CUSTOMERS_BY_BANKACCOUNT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/bank/customers-by-account/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Mobile Networks
  async [GET_MOBILE_NETWORKS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    // context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`beneficiary/momolisting${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get MOMO accounts
  async [GET_MOMOACCOUNTS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/momo/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Mobile money Details by id
  async [GET_MOBILE_MONEY_BY_ID](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/momo/id/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // update Mobile money Details
  async [UPDATE_MOBILE_NETWORKS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(`accounts/momo/update/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete beneficiary Mobile money by id
  async [DELETE_BENEFICIARY_MOBILE_MONEY](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(`accounts/momo/delete/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get Customers Associated with a MoMo Wallet
  async [GET_CUSTOMERS_BY_MOMOWALLET](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`accounts/momo/customers-by-wallet/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
